export default {"src":"/_next/static/media/0x6C16119B20fa52600230F074b349dA3cb861a7e3.59823e3e.svg","height":142,"width":152,"blurWidth":0,"blurHeight":0};